import { useConfig } from "../contexts/ConfigContext"
import { contentPath, modules } from "../config/pages"
import React, { useEffect, useState } from "react"
import { AppstoreOutlined, BarcodeOutlined, ShopOutlined, TeamOutlined, SettingOutlined, SwapOutlined, BarChartOutlined, DeploymentUnitOutlined } from "@ant-design/icons"
import { useHistory } from "react-router-dom"
import { ItemType } from "antd/es/menu/interface"
import { useUser } from "../contexts/UserContext"
import { SideBar as SharedSideBar } from "@ryo/ui"

const operationsOptions = [
  {key: modules.RegisterStorageItem, label:"Crear Elemento"},
  {key: modules.MovementList, label:"Movimientos Efectuados"},
  {key: modules.RegisterEntry, label:"Registrar Ingreso"},
  {key: modules.PendingEntriesList, label:"Ingresos Pendientes"},
  {key: modules.RegisterExit, label:"Registrar Salida"},
  {key: modules.PendingExitsList, label:"Salidas Pendientes"},
  {key: modules.StockOverrideList, label:"Pendientes de Ajuste"},
  {key: modules.StorageReports, label:"Informes", icon: <BarChartOutlined />},
]

const catalogOptions = [
  {key: modules.StorageItemList, label:"Catálogo de Elementos", icon: <BarcodeOutlined />},
  {key: modules.Traceability, label:"Trazabilidad", icon: <DeploymentUnitOutlined />},
  {key: modules.StoreList, label:"Almacenes", icon: <ShopOutlined />},
  {key: modules.ContactList, label:"Contactos", icon: <TeamOutlined />},
  {key: modules.Settings, label:"Configuración", icon: <SettingOutlined />},
]

function getMenuItems(permissions:any){
  const views = permissions.views || []
  
  const availableOperations = operationsOptions.filter(el => views.join().includes(el.key.toLowerCase()))
  const availableCatalogs = catalogOptions.filter(el => views.join().includes(el.key.toLowerCase()))

  const menuItems: any[] = []
  if(availableOperations.length){
    menuItems.push({
      key: "operations",
      icon: <SwapOutlined />,
      label: "Operaciones",
      children: availableOperations
    })
  }
  if(availableCatalogs.length){
    menuItems.push({
      key: "catalogs",
      icon: <AppstoreOutlined />,
      label: "Catálogos",
      children: availableCatalogs
    })
  }
  return menuItems
}

const getParentKey = (key: string,menuItems:ItemType[]) => {
  const parent = menuItems.find(item => 
    item && "children" in item && Array.isArray((item as any).children) &&
    (item as any).children.some((child: any) => child.key === key)
  );
  return parent?.key?.toString() ?? null;
};

function SideBar(props:any){
  const history = useHistory()
  const {config,updateConfig} = useConfig()
  const {user} = useUser()
  const menuItems = React.useMemo(() => getMenuItems(user.permissions), [user.permissions]);
  const [openKey, setOpenKey] = useState<string | null>(getParentKey(config.module,menuItems as any)); 
  
  useEffect(() => {
    setOpenKey(getParentKey(config.module,menuItems as any)); 
  }, [config.module, menuItems]);

  const handleOpenChange = (keys: string[]) => {
    setOpenKey(keys.length > 0 ? keys.at(-1) || null : null);
  };

  const toggleCollapsed = () => {
    updateConfig({sideCollapsed:!config.sideCollapsed})
  };

  const handleSelected = (key: string) => {
    const moduleSelectedKey = Object.keys(modules).find(k => modules[k as keyof typeof modules] === key)
    const module = modules[moduleSelectedKey as keyof typeof modules]
    updateConfig({module});
    history.push(contentPath[module].replace(":uidItem",""))
  }

  return(
    <SharedSideBar 
      activeKey={config.module}
      collapsed={config.sideCollapsed}
      isMobile={config.isMobile}
      menuItems={menuItems}
      openKey={openKey}
      onToggle={toggleCollapsed}
      onSelect={handleSelected}
      onOpenChange={handleOpenChange}
      title="Ryo Storage"
      logoSrc="/assets/icons/storage-sidebar.png"
    />
  )
}

export default SideBar